import App from './App.svelte';
import axios from 'axios';
import { push } from 'svelte-spa-router';
import ApiService from './api-service';
import 'smelte/src/tailwind.css';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import dayjs from 'dayjs';
import 'dayjs/locale/et';
dayjs.locale('et');
const refreshAuthLogic = failedRequest => {
    if (localStorage.getItem('refresh_token')) {
        return ApiService.refreshToken()
            .then(tokenRefreshResponse => {
            localStorage.setItem('access_token', tokenRefreshResponse.data.access_token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${tokenRefreshResponse.data.access_token}`;
            failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token;
            return Promise.resolve();
        });
    }
    else {
        return Promise.reject(failedRequest);
    }
};
createAuthRefreshInterceptor(axios, refreshAuthLogic);
if (localStorage.getItem('access_token') != null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
}
else {
    push('/login');
}
const app = new App({
    target: document.body,
    props: {},
    hydrate: true
});
export default app;
